import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=c9d94c36&scoped=true&"
import script from "./Safety.vue?vue&type=script&lang=js&"
export * from "./Safety.vue?vue&type=script&lang=js&"
import style0 from "./Safety.vue?vue&type=style&index=0&id=c9d94c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d94c36",
  null
  
)

export default component.exports